export const SirinaOkna = {
  data () {
    return {
      orientacija: 'top',
      orientacijaPrikazaTabele: '0'
    }
  },
  methods: {
    SirinaOknaPresegaVrednostTabela () {
      if (document.documentElement.clientWidth < this.mejnaSirinaTabela) {
        this.prikazTabele = '0'
      } else {
        this.prikazTabele = '1'
      }
    },
    SirinaOknaPresegaVrednost () {
      if (document.documentElement.clientWidth < this.mejnaSirina) {
        this.formaOrientacija = 'top'
      } else {
        this.formaOrientacija = 'left'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SirinaOkna.js